import { render, staticRenderFns } from "./controlsPosition-editor.vue?vue&type=template&id=11780f45&scoped=true"
import script from "./controlsPosition-editor.vue?vue&type=script&lang=js"
export * from "./controlsPosition-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11780f45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11780f45')) {
      api.createRecord('11780f45', component.options)
    } else {
      api.reload('11780f45', component.options)
    }
    module.hot.accept("./controlsPosition-editor.vue?vue&type=template&id=11780f45&scoped=true", function () {
      api.rerender('11780f45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-number/controlsPosition-editor.vue"
export default component.exports